export default function TeamGraphics() {
  return (
    <section className="flex flex-col gap-4 align-middle items-center">
      <h1>Graphics Page</h1>
      <p>Coming Soon</p>
    </section>
  );
}
